<!--
 * @Description: 
 * @Author: 
 * @Date: 2024-02-24 18:08:34
-->
<template>
    <div class="ranking-page">
        <el-menu
            v-if="!isMobileLayout"
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
            router
        >
            <el-menu-item
                v-for="item in menuList"
                :key="item.id"
                :index="item.path"
            >
                <b style="font-size: 28px"> {{ item.name }}</b>
            </el-menu-item>
        </el-menu>
        <div v-else class="ranking-nav-mobile">
            <router-link
                v-for="item in menuList"
                :key="item.id"
                :to="item.path"
                class="ranking-nav-card"
                :class="{ 'is-active': $route.path === item.path }"
            >
                {{ item.name }}
            </router-link>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        isMobileLayout() {
            return !!(this.$platform && this.$platform.isMobile);
        },
    },
    data() {
        return {
            menuList: [
                {
                    id: 1,
                    name: "总票房榜",
                    path: "/rankingList/totalBoxOfficeList",
                },
                {
                    id: 2,
                    name: "国内票房榜",
                    path: "/rankingList/domesticBoxOfficeList",
                },
                {
                    id: 3,
                    name: "国外票房榜",
                    path: "/rankingList/foreignBoxOfficeList",
                },
            ],
        };
    },
    methods: {},
};
</script>

<style scoped>
.el-menu {
    display: flex;
    justify-content: space-between;
}

.el-menu-item {
    font-size: 16px;
}

.ranking-nav-mobile {
    display: none;
}

@media (max-width: 768px) {
    .ranking-page {
        overflow-x: hidden;
    }

    .ranking-nav-mobile {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        gap: 12px;
        padding: 16px;
        background: #f4f5f7;
    }

    .ranking-nav-card {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 48px;
        padding: 10px 12px;
        text-align: center;
        text-decoration: none;
        color: #373d41;
        background: #ffffff;
        border-radius: 14px;
        box-shadow: 0 6px 18px rgba(31, 41, 55, 0.08);
    }

    .ranking-nav-card.is-active {
        background: #545c64;
        color: #ffd04b;
    }
}
</style>
